import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'pos-general-information-step',
  templateUrl: './general-information-step.component.html',
  styleUrls: ['./general-information-step.component.sass']
})
export class GeneralInformationStepComponent implements OnInit {

  @Input() generalnformationForm: FormGroup = new FormGroup({
    personality: new FormControl(""),
    personalityDescription: new FormControl(""),
    requestType: new FormControl("", Validators.required),
    creditPlan: new FormControl(""),
    creditPlanDescription: new FormControl(""),
    sellerCode: new FormControl(""),
    sellerName: new FormControl("")
  });
  @Input() readonly = false;
  @Output() requestTypeEmitter = new EventEmitter<string | `AVAL` | `CUSTOMER`>();
  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {


  }
}
